import ScheduleEvents from './ScheduleEvents';

export default ScheduleEvents;
